import { ChatConfig, MembersLibConfig, PermissionConfig, TabConfig } from '@lib/members/feature';

// Available tabs for health manager portal with permissions
export const healthManagerPortalTabs: TabConfig[] = [
  {
    link: 'profile',
    label: 'context.tabs.profile',
    icon: 'person',
    requiredPermission: 'view_profile',
    visible: true,
  },
  {
    link: 'guarantees',
    label: 'context.tabs.guarantees',
    icon: 'verified_user',
    requiredPermission: 'view_guarantees',
    visible: true,
  },
  {
    link: 'prescriptions',
    label: 'context.tabs.prescriptions',
    icon: 'medication',
    requiredPermission: 'view_prescriptions',
    visible: true,
  },
  {
    link: 'appointments',
    label: 'context.tabs.appointments',
    icon: 'calendar_today',
    requiredPermission: 'view_appointments',
    visible: true,
  },
  {
    link: 'documents',
    label: 'context.tabs.documents',
    icon: 'description',
    requiredPermission: 'view_documents',
    visible: true,
  },
];

// Chat configuration for health manager portal
export const healthManagerChatConfig: ChatConfig = {
  enabled: true,
  threadType: 'HealthManagerChannel',
  allowFileUpload: true,
  maxMessageLength: 5000,
  enableNotifications: true,
};

export const healthManagerPermissionConfig: PermissionConfig = {
  permissions: ['hm.read', 'hm.write', 'doctor.read', 'doctor.write'],
  roles: ['health_manager', 'admin'],
};

export const healthManagerMembersConfig: MembersLibConfig = {
  availableTabs: healthManagerPortalTabs.filter(tab => tab.visible),
  chatConfig: healthManagerChatConfig,
  permissionConfig: healthManagerPermissionConfig,
  features: {
    showDoctorEdit: true,
    showPartnerIdEdit: true,
    showChatButton: true,
    showExternalRefs: true,
    showFranchises: true,
    showPackageDescription: true,
    showMedicalHistory: true,
    showPrescriptions: true,
    showAppointments: true,
    showComments: true,
  },
};